import styled from 'styled-components';

export const Wrapp = styled.div`
  && {
    .section {
      padding: 25px 40px;
    }
    .header-choose {
      height: 75px;
      background-color: rgba(236, 255, 184, 1);
      padding-left: 60px;
      display: flex;
      align-items: center;
    }
    .btn-modal {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    .btn-modal > span {
      color: #a956ea;
      cursor: pointer;
    }
    .wrap-button {
      display: flex;
      justify-content: center;
    }
    .btn-save-step {
      width: 240px;
      height: 60px;
      background-color: #ff8a00;
      color: white;
      margin-top: 2rem;
    }
    .btn-save-step:hover {
      outline: none;
      border: none;
    }
    .disabled {
      background-color: #d2d2d2;
    }
    .table-billing {
      margin-top: 10px;
    }
    #btn-small {
      width: 80px;
      height: 35px;
      margin-left: 1rem;
    }
    .bill-error {
      margin-top: 10px;
      color: red;
    }
    .wn-error {
      color: red;
    }
    .consultation-error {
      margin-top: 10px;
      color: red;
      text-align: center;
    }
    .header-degree-registration {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      p {
        margin: 0;
      }
      .search-form {
        display: flex;
        flex-direction: row;
        .submit-button {
          background: #ff8a00;
          color: white;
          font-weight: 500;
          border: 1px solid #ff8a00;
        }
        .reset-button {
          color: #ffffff;
          background: rgba(196, 196, 196, 1);
          font-weight: 500;
          margin-left: 5px;
          border: 1px solid rgba(196, 196, 196, 1);
        }
      }
    }
  }
`;
